<template>
    <router-view />
</template>

<script>
export default {
  name: "LoginLayout",
}
</script>

<style scoped>

</style>
